import { GET, PATCH } from '../../common/common.service'
import endpointTanks from './endpoints'

const TanksService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointTanks.LOAD(filter, sort, limit, skip)),
  getById: async (id) => GET(endpointTanks.BY_ID(id)),
  updateMinStock: async ({ ownStationId, tankNum, body }) =>
    PATCH(endpointTanks.UPDATE_MIN_STROCK({ ownStationId, tankNum }), body),
}

export default TanksService
